/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./countUp.vue?vue&type=template&id=21cfca30&scoped=true"
import script from "./countUp.vue?vue&type=script&lang=js"
export * from "./countUp.vue?vue&type=script&lang=js"
import style0 from "./countUp.vue?vue&type=style&index=0&id=21cfca30&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21cfca30",
  null
  
)

export default component.exports